module.exports = __webpack_public_path__ + "img/wmjy.7ad10583.jpg";